<template>
	<div>
		<div class="row mb-3">
			<div class="col-12 col-md-6 col-lg-8">
				<h1><em class="fas fa-users"></em> Users</h1>
			</div>
			<div class="col-12 col-md-6 col-lg-4 text-right">
				<router-link to="/user/0" class="btn btn-primary"><em class="fas fa-user-tie"></em> Add User</router-link>
			</div>
		</div>

		<div class="list-group">
			<router-link :to="'user/' + u.user_id" v-for="u in users" :key="u.user_id" class="list-group-item list-group-item-action d-flex justify-content-between">
				<div>{{u.fname}} {{u.lname}}</div>
				<div>{{u.email}}</div>
			</router-link>
		</div>
	</div>
</template>

<script>
export default
{
	name: 'Users',
	props: ["session_id", "logged_in", "current_user"],
	data: function()
	{
		return {
			users: [],
			roles: [],
			loading: true
		}
	},
	mounted: function()
	{
		if(!this.logged_in)
		{
			return;
		}

		// if(!this.userHasAction(this.current_user, ['ADMIN']))
		// {
		// 	this.$router.push("/admin");
		// }

		this.loadUsers();
	},
	methods:
	{
		loadUsers: function()
		{
			var vm = this;
			vm.loading = true;
			vm.startLoading();

			this.CORS("GET", "/registration/users", null,
			function(response)
			{
				vm.users = response;
				vm.loading = false;
				vm.stopLoading();
			}, function(response)
			{
				vm.showError("Error Loading Users", response.responseText, true, null);
				vm.loading = false;
				vm.stopLoading();
			})
		}
	}
}
</script>
